var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-bottom p-1 bg-white"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('b-avatar',{staticClass:"mr-1"}),_c('h5',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.conversationName)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }